import { Component, Input, OnInit } from '@angular/core';
import { SortDirection } from 'src/app/library/enums/filters/sort/sort-direction';
import { ISort } from 'src/app/library/interfaces/filters/sort/sort';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'sort-direction-select',
    templateUrl: './sort-direction-select.component.html',
    styleUrls: ['./sort-direction-select.component.scss']
})
export class SortDirectionSelectComponent implements OnInit {
    @Input() sort: ISort;
    @Input() disableRemove: boolean = false;

    public sortDirectionEnum = SortDirection;

    constructor(private filterService: FilterService) {}

    ngOnInit() {}

    public remove() {
        this.filterService.removeSort(this.sort);
    }

    public directionChange() {
        this.sort.direction =
            this.sort.direction == SortDirection.Descending
                ? SortDirection.Ascending
                : SortDirection.Descending;
        this.filterService.updateSort(this.sort);
        this.filterService.filterChangeEvent();
    }

    get selectedSortsLength() {
        return this.filterService.filterConfig?.sorts?.filter(x => x.selected)
            .length;
    }
}
